import { Component, ViewEncapsulation, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppState } from '../../../app/app.service';
import { AuthService } from '../../../app/auth/auth.service';
import { AuditLogService } from './auditlog.service';
import { DatePipe } from '@angular/common';
import AuditLogDialogComponent from './auditlog-dialog/auditlog-dialog.component';
import { VcaAlertsService } from './../../../common/vca-alerts';
import JSONFormatter from 'json-formatter-js';
import { LocalStorageService } from 'ngx-webstorage';
import { TranslateService } from '@ngx-translate/core';
import { ClientUtilities } from './utils/client-utils';
import { environment } from 'environments/environment';

var clipboardJs = require("clipboard-js");
let fullScreenOverlayGuest = require('./utils/fullscreenOverlayGuest');
const _ = require('lodash');

@Component({
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  styles: [require('./auditlog.scss')],
  templateUrl: './auditlog.component.html',
  providers: [AuditLogService]
})

export class AuditLogApp {
  private isVsphereClient: boolean = false;
  private startTime: string = '';
  private endTime: string = '';
  private alData: any = [];
  private getAuditLogHandler = null;
  private isLoading: boolean = false;
  private eventJsonData: any = [];
  private auditLogSearchItem: string = '';
  private localHcspList: any = null;
  private selectedHcsp: any;
  private alertMessage: string = '';
  private dialogue: boolean = false;
  private logDuration = {};
  private systemStartTime: string = '';
  private systemEndTime: string = '';
  private startTimeForAuditQuery: string = '';
  private endTimeForAuditQuery: string = '';
  private auditLogsDetail = {};
  private auditLogArchiveLink: string = '';
  private modalSize = '';
  private viewJSON: boolean = false;
  private showJsonBtn: boolean = false;
  private inValidDate: boolean = false;
  private content: any;

  private formatter; // = new JSONFormatter(this.myJSON);
  private archiveDisabled: boolean=true;
  preparingDownload = false;

  @ViewChild('auditlogDialog') public auditlogDialog: AuditLogDialogComponent;

  constructor(public appState: AppState,  public router: Router, private titleService: Title,
              public auditLogService: AuditLogService, private alert: VcaAlertsService, private changeDetector: ChangeDetectorRef,
              public authService: AuthService, private localStorage: LocalStorageService, private translate: TranslateService) {
      const me = this;
      const sDate = new Date(), eDate = new Date();
      sDate.setHours(sDate.getHours());
      eDate.setHours(eDate.getHours() + 1);
      this.startTime = this.getInDateTimeFormat(sDate);
      this.endTime = this.getInDateTimeFormat(eDate);
      const roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];
      if (this.authService.isVCDGVRDepricated && _.includes(roles, 'System Administrator')) {
        // If roles contains 'System Administrator' load audit log directly.
        me.getAuditLogDurationForSysAdmin();
      } else {
        this.auditLogService.getContext().then((x) => {
          me.localHcspList = x.data.items;
        //  if (me.localHcspList && me.localHcspList.length === 1) {
         if (me.localHcspList && me.localHcspList.length >= 1) {
        me.selectedHcsp = me.localHcspList[0];
            me.getAuditLogDuration();
          }
          //me.getAuditLogDuration();
        });
      }
  }

  public ngOnInit() {
    const path = (window.location.pathname.match(/(.*)(\/auditlog-ui)(\/.*|$)/) || [])[1];
    this.isVsphereClient = !!path && ClientUtilities.runningInPluginUI();

    const me = this;
    this.auditLogService.queryHcmInstances(
        () => setTimeout(() => me.initApplication(), 10),
        null);
  }

  public initApplication() {
  }

  public ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }

  public setTitle(newTitle: string) {
      const title = this.titleService.getTitle();
      this.titleService.setTitle(`${title} - ${newTitle}`);
  }

  public logout() {
    // this.authService.logout();
    this.router.navigate(['/login']);
  }

  // Check if dates selected are valid for selected time windows to see Audti Logs

  public filterLogs() {
    let systemStartDate;
    if (this.systemStartTime) {// systemStartTime is start time for auditQuery, it is provided by REST query "startTimeForAuditQuery" and is called in getAuditLogDuration() in constructor
      systemStartDate = new Date(this.systemStartTime.replace(/-/g, ','));
    }

    // start and end times are user selectable times for requesting logs, by default both times are initialized as date object in constructor
    // cache startTime and endTime and convert to date with year month and day format
    const startDate = new Date(this.startTime.toString().replace(/-/g, ','));
    const endDate = new Date(this.endTime.toString().replace(/-/g, ','));
    let site = this.selectedHcsp; // get siteInfo from dropdown...  this.localSiteList

    if (!site && this.localHcspList && this.localHcspList.length > 0) {
      site = this.selectedHcsp = this.localHcspList[0];
    }

    this.logsAvailable = true;
    // end date cannot be before start date e.g start 05/25  end 05/04
    if (startDate.getTime() > endDate.getTime()) {
      this.alert.danger('Start Time cannot be greater than End Time');
      this.dialogue = true;
      this.alertMessage = 'Archive request date from' + this.startTime + ' to ' + this.endTime + ' is not valid. Please select an end date on or after ' + this.startTime;
      this.alData = null;
      this.showJsonBtn = false;
      this.inValidDate = true;
    } else if ((endDate.getTime() - startDate.getTime()) > (86400000 * 31)) {
      this.alert.danger('Query interval cannot exceed one Month');
      this.alertMessage = 'Query interval cannot exceed one month, please select dates between ' + this.getDateOnlyFormat(systemStartDate) + ' and ' + this.systemEndTime;
      this.endTime = this.systemEndTime;
      this.viewJSON = false;
      this.archiveDisabled = true;
    } else {
      this.isLoading = true;
      this.getEventLogs(site, this.startTime, this.endTime);
      this.inValidDate = false;
      this.archiveDisabled = false;
    }

    if ((this.getDateOnlyFormat(systemStartDate) > this.getDateOnlyFormat(startDate)) && (this.getDateOnlyFormat(systemStartDate) > this.getDateOnlyFormat(endDate))) { // Check user selected with system start date
      this.alert.danger('Log start sime cannot be greater than system start time');
      this.alertMessage = 'Audit log start date should be from ' + this.getDateOnlyFormat(systemStartDate);
      this.logsAvailable = false;
      this.viewJSON = false;
    }
    this.validLogDate();
  }

  public getEventLogs(site, start, end) {
    const me = this;
    const auditLogSearchParams = { // TBD Change date to orgination date
      start: this.startTime,        // this.getHourFormat(new Date(this.startTime)),
      end: this.endTime,       // this.getHourFormat(new Date(this.endTime)),
      searchContent: this.auditLogSearchItem
    };

    this.auditLogService.loadAuditLogsData(site, auditLogSearchParams).then((alJsonData) => {
      me.alData = alJsonData ? alJsonData.events : [];
      me.isLoading = false;
    });
  }

  public defaultLogs() {
    const startDate = new Date(this.startTime);
    const endDate = new Date(this.endTime);
    let site = this.selectedHcsp; // get siteInfo from dropdown...  this.localSiteList
    if (!site && this.localHcspList && this.localHcspList.length > 0) {
      site = this.selectedHcsp = this.localHcspList[0];
    }

    if (startDate.getTime() > endDate.getTime()) {
        this.alert.danger('Start time cannot be greater than end time');
    } else if ((endDate.getTime() - startDate.getTime()) > 86400000) {
        this.alert.danger('Query interval cannot exceed one day');
    } else {
        this.isLoading = true;
    }

  }

  public getDefaultAuditLogData(start, end) {
    const me = this;
    const site = this.selectedHcsp;
    const auditLogSearchParams = { // TBD Change date to orgination date
      start, // this.getHourFormat(new Date(this.startTime)),
      end// this.getHourFormat(new Date(this.endTime)),
    };
    // this.auditLogService.getAllAuditLogData(site, auditLogSearchParams).then( alJsonData => {
    this.auditLogService.loadAuditLogsData(site, auditLogSearchParams).then((alJsonData) => {
      me.alData = alJsonData ? alJsonData.events : [];
      me.isLoading = false;
      
    }).catch(function(e){ 
      let errorMsg = JSON.parse(e._body);
      //console.log('catch error',errorMsg.message);//me.inValidDateSelection=true;
      me.archiveDisabled = true;
    me.alert.warning(errorMsg.message,'date-alert');
    });
    
  }

  private logsAvailable: boolean = false;
  public getAuditLogDuration() {
    const me = this;
    const site = me.selectedHcsp;
    this.auditLogService.getAuditlogTimeLineDuration(site).then((resp) => {
      me.logDuration = resp;
      me.auditLogsDetail['startTimeForAuditQuery'] = this.getDateOnlyFormat(new Date(resp.startTimeForAuditQuery));
      me.auditLogsDetail['endTimeForAuditQuery'] = this.getDateOnlyFormat(new Date(resp.endTimeForAuditQuery));
      me.auditLogsDetail['startTimeForAuditArchive'] = this.getDateOnlyFormat(new Date(resp.startTimeForAuditArchive));
      if (resp.startTimeForAuditArchive === 0) {
        me.archiveDisabled = true;
      }
      me.auditLogsDetail['endTimeForAuditArchive'] = this.getDateOnlyFormat(new Date(resp.endTimeForAuditArchive));
      this.startTimeForAuditQuery = resp.startTimeForAuditQuery;
      this.endTimeForAuditQuery = resp.endTimeForAuditQuery;
      me.systemStartTime = me.getDateOnlyFormat(new Date(resp.startTimeForAuditQuery));
      me.startTime = me.getDateOnlyFormat(new Date(resp.startTimeForAuditQuery));
      me.systemEndTime = me.getDateOnlyFormat(new Date(resp.endTimeForAuditQuery));
      me.endTime = me.getDateOnlyFormat(new Date(resp.endTimeForAuditQuery));
      me.getDefaultAuditLogData(me.startTime, me.endTime); // Display default AuditLog
    });
    if ((me.auditLogsDetail['startTimeForAuditArchive'] !== 0) && ((me.auditLogsDetail['endTimeForAuditArchive'] !== 0))) {
      if(me.alData.length != 0) {
        me.archiveDisabled = false;
      }
      me.logsAvailable = true;
    }
  }

  public getAuditLogDurationForSysAdmin() {
    const me = this;
    this.auditLogService.getAuditlogTimeLineForSystemAdmin().then((resp:any) => {
      me.logDuration = resp;
      me.auditLogsDetail['startTimeForAuditQuery'] = this.getDateOnlyFormat(new Date(resp.startTimeForAuditQuery));
      me.auditLogsDetail['endTimeForAuditQuery'] = this.getDateOnlyFormat(new Date(resp.endTimeForAuditQuery));
      me.auditLogsDetail['startTimeForAuditArchive'] = this.getDateOnlyFormat(new Date(resp.startTimeForAuditArchive));
      me.auditLogsDetail['endTimeForAuditArchive'] = this.getDateOnlyFormat(new Date(resp.endTimeForAuditArchive));
      this.startTimeForAuditQuery = resp.startTimeForAuditQuery;
      this.endTimeForAuditQuery = resp.endTimeForAuditQuery;
      me.systemStartTime = me.getDateOnlyFormat(new Date(resp.startTimeForAuditQuery));
      me.startTime = me.getDateOnlyFormat(new Date(resp.startTimeForAuditQuery));
      me.systemEndTime = me.getDateOnlyFormat(new Date(resp.endTimeForAuditQuery));
      me.endTime = me.getDateOnlyFormat(new Date(resp.endTimeForAuditQuery));
      me.getDefaultAuditLogData(me.startTime, me.endTime); // Display default AuditLog
    });
    if ((me.auditLogsDetail['startTimeForAuditArchive'] !== 0) && ((me.auditLogsDetail['endTimeForAuditArchive'] !== 0))) {
      me.logsAvailable = true;
    }
  }

  private getDateOnlyFormat(date: Date) {
    return new DatePipe('en-US').transform(date, 'yyyy-MM-dd');
  }
  private getInDateTimeFormat(date: Date) {
    return new DatePipe('en-US').transform(date, 'y-MM-dd HH:00:00');
  }

  private getUTCFormat(date) {
    return new Date(date).toUTCString();
  }

  public displayEventJSON(evn, event) {
    const deep = _.cloneDeep(evn);
    this.dialogue = true;
    delete deep._source;
    this.eventJsonData = deep;
    this.showJsonBtn = true;
    this.formatter = new JSONFormatter(this.eventJsonData);
    this.content = this.formatter.render();
    this.formatter.openAtDepth(1);
  }

  private showJSONContent(contentID, evt) {
    const me = this;
    if (this.viewJSON === false) {
      document.getElementById('json').innerHTML = '';
    } else {
      me.content = me.content;
      document.getElementById('json').appendChild(me.content);
      this.formatter.openAtDepth(3);
    }
  }

  private getHourFormat(date: Date) {
    return new DatePipe('en-US').transform(date, 'yyyy-MM-dd-HH');
  }

  public printDate(stime) {
    if (!stime) {
      return '';
    } else {
      return new Date(stime).toString();
    }
  }

  private searchLogData() {
    this.filterLogs();
  }

  private downloadAuditlog(event, archiveStartTime, archiveEndTime) {
    event.preventDefault();
    const me = this;
    me.validLogDate();
    const site = this.selectedHcsp;
    if (me.systemStartTime > me.startTime) {
      this.logsAvailable = true;
    }
    const downloadLink = this.auditLogService.getDownloadUrl(site, archiveStartTime, archiveEndTime);
    me.auditLogArchiveLink = downloadLink;
    const fileName = `auditArchive-${archiveStartTime}-to-${archiveEndTime}.tar.gz`;
    this.preparingDownload = true;
    fetch(downloadLink, {
        headers:{
            'x-hm-authorization': environment.token ? atob(environment.token) : null
        }
    })
    .then((response) => response.blob())
    .then((blob) => {
        this.preparingDownload = false;
        let _url = window.URL.createObjectURL(blob);
        const elem = document.createElement('a');
        elem.setAttribute('display', 'none');
        elem.setAttribute('href', _url);
        elem.setAttribute('download', fileName);
        // fix for firefox browser, as firefox don't entertain click on elements not attached to DOM.
        document.querySelector('body').appendChild(elem);
        elem.click();
        elem.remove();
    })
    .catch((err) => {
      this.preparingDownload = false;
      this.alertMessage = `Error downloading audit logs file requested.Reason: ${err}`;
    });
  }

  private closeDialogue() { // Close Audit log data dialogue and reset messages
    this.alertMessage = '';
    this.eventJsonData = '';
    this.modalSize = 'lg';
    document.getElementById('json').innerHTML = '';
    this.viewJSON = false;
  }

  private copyJson() {
    const copyJson = this.eventJsonData;
    clipboardJs.copy(JSON.stringify(copyJson));
  }

  private getKeys(obj) {
    return Object.keys(obj);
  }

  private checkArchive() {
    const me = this;
    const orignalStartTime = new Date(me.systemStartTime);
    const archiveEndTimeSelected = new Date(me.endTime);

    const timeDelay = 1;
    if ((me.auditLogsDetail['startTimeForAuditArchive'] === this.getDateOnlyFormat(new Date(0)))) {
      me.archiveDisabled = true;
      return;
    }

    if (archiveEndTimeSelected > orignalStartTime) {
      me.archiveDisabled = true;
    }

    let startTimeForAuditArchive = new Date(me.auditLogsDetail['startTimeForAuditArchive']);
    startTimeForAuditArchive = new Date(startTimeForAuditArchive.getTime() + timeDelay * 24 * 60 * 60 * 1000);
    const dayPlus = new Date();
    if (startTimeForAuditArchive > archiveEndTimeSelected) {
      me.archiveDisabled = true;
    } else {
     // me.archiveDisabled = false;
    }
    this.checkEndTime();
  }
public inValidDateSelection: boolean = false;

  private checkEndTime() {
    const me = this;
    const orignalStartTime = new Date(me.systemStartTime);
    const orignalEndTime = new Date(me.systemEndTime);
    const timeSelected = new Date(me.endTime);
    if ((timeSelected > orignalEndTime || timeSelected === orignalStartTime) || ((timeSelected < orignalStartTime))) { // selected time is after auditlogs were created
      //me.archiveDisabled = false;
      //this.inValidDateSelection = true;
      this.alertMessage = 'Archive request date from ' + this.startTime + ' to ' + this.endTime + ' is not valid. End date should be between ' + me.systemStartTime + ' and ' + me.systemEndTime;
      this.alert.warning(this.alertMessage,'date-alert');
      me.endTime = me.systemEndTime;
    }
  }

  private checkStartTime(e) {
    const me = this;
    const orignalStartTime =  new Date(me.systemStartTime); // me.getDateOnlyFormat(new Date(me.systemStartTime))
    const orignalEndTime = new Date( me.endTime);
    const timeSelected = new Date(me.startTime); // me.getDateOnlyFormat(new Date(this.startTime))
    if ((timeSelected < orignalStartTime || timeSelected === orignalStartTime) || ((timeSelected > orignalEndTime))) { // selected time is after auditlogs were created
     // me.archiveDisabled = false;
      //this.inValidDateSelection = true;
      this.alertMessage = 'Archive request date from ' + this.startTime + ' to ' + this.endTime + ' is not valid. Start and end date should be between ' + me.systemStartTime + ' and '  + me.systemEndTime;
      this.alert.warning(this.alertMessage,'date-alert');
      me.startTime = me.systemStartTime;
    }
  }

  private validLogDate() {
    //Selected Time window range should be within 31 days
    let selectedLogStartDate = new Date(this.startTime);
    let selectedLogendDate = new Date(this.endTime);
    let selectedLogtimeWindowInMilliSecs = selectedLogendDate.valueOf() - selectedLogStartDate.valueOf();
    let selectedLogTimeWindowInDays = Math.round((selectedLogtimeWindowInMilliSecs/(1000*60*60*24)));

    let logsAvailableWindow=31;
    if(selectedLogTimeWindowInDays > logsAvailableWindow) {
      this.inValidDateSelection = true;
      this.alertMessage = 'Start and end log dates should be within 30 days'
      return;
    }
    //Time window from selected start time until logs last generated
    //for download this should not be more then 180 days
      
     let sysEndTime = this.systemEndTime;
     let sysEndTimeInMilliSecs = new Date(sysEndTime).valueOf();
     let sysStartTime = this.startTime;
     let sysStartTimeInMilliSecs = new Date(sysStartTime).valueOf();
     let logsDuration =  Math.round(sysEndTimeInMilliSecs/(1000*60*60*24) - sysStartTimeInMilliSecs/(1000*60*60*24));
     let timeLimitforDownloads = 180;
     if(logsDuration > timeLimitforDownloads) {
      this.archiveDisabled = true;
      this.alert.warning('Logs are unavailable for download on selected dates. Logs are only available for download for past 180 days or less','date-alert');
     }
  }
  
}



// WEBPACK FOOTER //
// ./src/auditlog/src/auditlog-ui/auditlog.component.ts